const routes = [
  {
    path: '/faqs',
    name: 'site-faqs',
    meta: {
      authRequired: true,
      roles: []
    },
    component: () => import('./Index.vue')
  },
  {
    path: '/faqs/new',
    name: 'site-faqs-new',
    meta: {
      authRequired: true,
      roles: []
    },
    component: () => import('./Form.vue')
  },
  {
    path: '/faqs/:id/edit',
    name: 'site-faqs-edit',
    meta: {
      authRequired: true,
      roles: []
    },
    component: () => import('./Form.vue')
  }
]

export { routes }
export default routes
